<template>
    <div>
        <div class="sezione">
            <div class="text-center">
                <img :src="this.news_image"
                     class="img-thumbnail img-fluid"
                     style="max-height:400px; margin-bottom:30px;">
            </div>
            <p class="gray">
                <i class="fa fa-calendar mr-2"></i>
                <i>{{this.news_date}}</i>
            </p>
            <p class="text-justify">{{this.news_titolo}},</p>
            <p class="text-justify" v-html="this.news_text"></p>
            <div class="row">
                <div class="col-md-6">
                    <router-link :to="{name: 'news.details', params: {id: this.next_news_id}}">
                        <button type="button" class="btn btn-default" :disabled="!this.next_news_id">
                            &laquo;{{$t('prenotazione_tavolo.precedente')}}
                        </button>
                    </router-link>
                </div>
                <div class="col-md-6 text-right">
                    <router-link :to="{name: 'news.details', params: {id: this.previous_news_id}}">
                        <button type="button" class="btn btn-default" :disabled="!this.previous_news_id">
                            {{$t('prenotazione_tavolo.successivo')}}&raquo;
                        </button>
                    </router-link>
                </div>
            </div>
        </div>
        <hr>
        <div class="container">
            <div class="row row-sezione">
                <div class="col-12 text-center">
                    <router-link :to="{name: 'news.list'}">
                        <button type="button" class="btn btn-default">
                            {{$t('prenotazione_tavolo.torna_lista')}}
                        </button>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getNews} from "../../api/restaurant";
    import {getImage} from "../../api/core";
    import {mapState, mapActions} from "vuex";
    import moment from 'moment';

    export default {
        data: function () {
            return {
                news: null,
                previous_news_id: 0,
                next_news_id: 0,
            }
        },
        created() {
            this.fetchNews();
        },
        computed: {
            news_date: function () {
                if (this.news) {
                    return moment(this.news.created_at).locale(this.language).format('dddd DD MMMM YYYY');
                }

                return null;
            },
            news_titolo: function () {
                return this.news ? this.news.traduzione.titolo : null;
            },
            news_image: function () {
                if (this.news) {
                    return getImage(this.language, this.id_ristorante, this.news.foto_codice);
                }

                return null;
            },
            news_text: function () {
                if (this.news) {
                    return this.news.traduzione.testo.replace(/\n/g, '<br>');
                }

                return null;
            },
            ...mapState('localization', {
                language: state => state.language
            }),
            ...mapState('restaurant', {
                targa: state => state.targa,
                locale: state => state.locale,
                id_ristorante: state => state.id
            })
        },
        watch: {
            language: function (newLanguage, oldLanguage) {
                this.fetchNews();
            },
            $route(to, from) {
                // react to route changes...
                this.fetchNews();
            }
        },
        methods: {
            fetchNews: function () {
                this.showLoading(true);
                getNews(this.language, {
                    id_ristorante: this.id_ristorante,
                    id_locale: this.locale.id,
                    id: this.$route.params.id,
                    id_news_precedente: true,
                    id_news_successiva: true
                }).then(response => {
                    this.news = response.news;
                    this.next_news_id = response.news_successiva ? response.news_successiva : 0;
                    this.previous_news_id = response.news_precedente ? response.news_precedente : 0;
                }).catch(messages => {
                    //la news non esiste, torno alla lista
                    this.$router.replace('/news');
                }).finally(() => {
                    this.showLoading(false);
                });
            },
            ...mapActions('global', [
                'showLoading'
            ])
        }
    }
</script>
